import React from "react";
import logo from "../assets/img/logo.svg";
import headerLogo from "../assets/img/logo-wave.svg";
import wellExperienced from "../assets/img/home-page/well-experienced.svg";
import fastDelivery from "../assets/img/home-page/fast-delivery.svg";
import leadingBrand from "../assets/img/home-page/leading-brand.svg";
import audio from "../assets/img/shop-all-products/audio.svg";
import automotive from "../assets/img/shop-all-products/automotive.svg";
import avtv from "../assets/img/shop-all-products/av-tv.svg";
import cableConnectors from "../assets/img/shop-all-products/cable-connectors.svg";
import celluar from "../assets/img/shop-all-products/celluar.svg";
import communication from "../assets/img/shop-all-products/communication.svg";
import dataComputer from "../assets/img/shop-all-products/data-computer.svg";
import electronic from "../assets/img/shop-all-products/electronic.svg";
import power from "../assets/img/shop-all-products/power.svg";
import security from "../assets/img/shop-all-products/security.svg";
import service from "../assets/img/shop-all-products/service.svg";
import acceptablePayments from "../assets/img/acceptable-payments.svg";
import footerLogo from "../assets/img/footer-logo.svg";
import brand1 from "../assets/img/category-list/brand1.png";
import category1 from "../assets/img/home-page/category1.svg";
import category2 from "../assets/img/home-page/category2.svg";
import category3 from "../assets/img/home-page/category3.svg";
import audioTechnicaLogo from "../assets/img/brand-view/Audio-Technica-logo.png";
import subBrand1 from "../assets/img/category-list/sub-brand1.png";
import subBrand2 from "../assets/img/category-list/sub-brand2.png";
import subBrand3 from "../assets/img/category-list/sub-brand3.png";
import subBrand4 from "../assets/img/category-list/sub-brand4.png";
import subBrand5 from "../assets/img/category-list/sub-brand5.png";
import subBrand6 from "../assets/img/category-list/sub-brand6.png";
import subBrand7 from "../assets/img/category-list/sub-brand7.png";
import subBrand8 from "../assets/img/category-list/sub-brand8.png";
import product2 from "../assets/img/home-page/product-image/product2.png";
import product3 from "../assets/img/home-page/product-image/product3.png";
import product4 from "../assets/img/home-page/product-image/product4.png";
import product5 from "../assets/img/home-page/product-image/product5.png";
import product6 from "../assets/img/home-page/product-image/product6.png";
import product7 from "../assets/img/home-page/product-image/product7.png";
import product8 from "../assets/img/home-page/product-image/product8.png";
import product9 from "../assets/img/home-page/product-image/product9.png";
import product10 from "../assets/img/home-page/product-image/product10.png";
import product11 from "../assets/img/home-page/product-image/product11.png";
import product12 from "../assets/img/home-page/product-image/product12.png";
import product13 from "../assets/img/home-page/product-image/product13.png";
import product14 from "../assets/img/home-page/product-image/product14.png";
import product15 from "../assets/img/home-page/product-image/product15.png";
import product16 from "../assets/img/home-page/product-image/product16.png";
import product17 from "../assets/img/home-page/product-image/product17.png";
import product18 from "../assets/img/home-page/product-image/product18.png";
import product19 from "../assets/img/home-page/product-image/product19.png";
import product20 from "../assets/img/home-page/product-image/product20.png";
import product21 from "../assets/img/home-page/product-image/product21.png";
import shoppingCart from "../assets/img/cart/shopping-cart.svg";
import walletNoCard from "../assets/img/my-account/wallet-nocard.svg";
import noAddressSvg from "../assets/img/my-account/no-address.svg";

import accPaySvg from "../assets/img/checkout/acc-pay.svg";
import masterSvg from "../assets/img/checkout/master.svg";
import visaSvg from "../assets/img/checkout/visa.svg";
import amexSvg from "../assets/img/checkout/amex-card.svg";
import cardsSvg from "../assets/img/checkout/credit-card-icons.svg";
import ccCardsSvg from "../assets/img/checkout/cc-card-icons.svg";
import walletSvg from "../assets/img/checkout/wallet.svg";
import trackingSvg from "../assets/img/checkout/tracking.svg";
import noInternet from "../assets/images/icon-no-internet-100.png";
import pdfDownloadSuccess from "../assets/img/products/download-success.svg";
import instructions from "../assets/images/auth/instructions.svg";
import signupImg from "../assets/images/auth/signup_img.jpg";
import excelUpload from "../assets/img/excel-upload.svg";
import pdfOutlineSvg from "../assets/img/catalogue/icon/pdfOutline.svg";
import eyeOpenSvg from "../assets/img/catalogue/icon/eyeOpen.svg";
import gpaySvg from "../assets/img/checkout/gpay.svg";
import gpayWalletSvg from "../assets/img/checkout/gpay-wallet-new.svg";
import gpayWalletNewSvg from "../assets/img/checkout/gpay-wallet-new.svg";
import feedbackSvg from "../assets/img/feedback/feedbackIconDataUrl";

const MyAccountHandSVG = () => (
  <svg className="wave-icon" width={18} height={18} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.05062 23.2616C6.8006 23.2116 6.60058 23.1615 6.35056 23.0615C6.10054 22.9615 5.90052 22.9115 5.7005 22.8115C5.25046 22.6115 4.85043 22.3615 4.45039 22.0615C3.65032 21.5114 3.00026 20.7613 2.50022 19.8613C2.00018 19.0112 1.70015 18.0111 1.65014 17.061C1.60014 16.561 1.65014 16.1109 1.70015 15.6109C1.75015 15.3609 1.80016 15.1608 1.85016 14.9108C1.90017 14.6608 2.00018 14.4608 2.05018 14.2108L2.10018 14.9108C2.10018 15.1608 2.15019 15.3609 2.20019 15.6109C2.2502 16.0609 2.35021 16.511 2.45022 16.911C2.65023 17.7611 2.95026 18.5611 3.4003 19.3112C3.85034 20.0613 4.35038 20.7613 5.00044 21.4114C5.30047 21.7114 5.6505 22.0114 6.00053 22.3115C6.15054 22.4615 6.35056 22.6115 6.55057 22.7615L7.05062 23.2616ZM6.90061 25.0617C6.75059 25.1617 6.55057 25.2117 6.35056 25.2617C6.15054 25.3117 6.00053 25.3617 5.80051 25.3617C5.45048 25.4117 5.05044 25.4617 4.65041 25.4117C3.90034 25.3617 3.10027 25.1617 2.45022 24.8117C1.75015 24.4617 1.1501 23.9116 0.750066 23.2616C0.550048 22.9615 0.350031 22.6115 0.200018 22.2615C0.150013 22.1115 0.100009 21.9114 0.0500043 21.7114C0.0500043 21.5614 0 21.4114 0 21.2114C0.150013 21.3614 0.250022 21.5114 0.350031 21.6114C0.500044 21.7614 0.600053 21.9114 0.700061 22.0114C0.950083 22.2615 1.1501 22.5115 1.40012 22.7115C1.90017 23.1615 2.40021 23.5616 3.00026 23.8616C3.55031 24.1616 4.20037 24.4117 4.80042 24.6117C5.10045 24.7117 5.45048 24.7617 5.80051 24.8617C5.95052 24.9117 6.15054 24.9117 6.30055 24.9617C6.55057 25.0117 6.70059 25.0117 6.90061 25.0617ZM18.2016 0.759588C18.4516 0.809592 18.6516 0.909601 18.9017 1.00961C19.1517 1.10962 19.3517 1.20963 19.5517 1.30964C20.0018 1.55966 20.4018 1.80968 20.8018 2.10971C21.6019 2.70976 22.252 3.50983 22.702 4.40991C23.152 5.30999 23.4021 6.31007 23.4021 7.26016C23.4021 7.7602 23.352 8.21024 23.252 8.71028C23.202 8.9603 23.152 9.16032 23.052 9.41034C22.952 9.66037 22.902 9.86038 22.802 10.0604L22.752 9.36034C22.752 9.11032 22.752 8.9103 22.702 8.66028L22.552 7.31016C22.402 6.46009 22.1019 5.61001 21.7019 4.80994C21.3019 4.00987 20.8018 3.30981 20.2018 2.65975C19.9017 2.30972 19.5517 2.0097 19.2517 1.65967C19.1017 1.50965 18.9017 1.35964 18.7016 1.20963L18.2016 0.759588ZM22.552 0.55957C22.752 0.609575 22.902 0.659579 23.052 0.759588C23.202 0.809592 23.4021 0.909601 23.5521 1.00961C23.8521 1.20963 24.1521 1.40964 24.4521 1.65967C25.0022 2.15971 25.4522 2.75976 25.7023 3.45982C26.0023 4.15989 26.1023 4.90995 26.0023 5.66002C25.9523 6.01005 25.8523 6.36008 25.7523 6.71011C25.7023 6.86012 25.6022 7.06014 25.5522 7.21015C25.4522 7.36016 25.4022 7.51018 25.2522 7.66019V7.16015V6.6601C25.2522 6.31007 25.2022 6.01005 25.2022 5.71002C25.1022 5.05996 25.0022 4.45991 24.7522 3.90986C24.5021 3.30981 24.2021 2.80977 23.8521 2.25972C23.6521 2.0097 23.4521 1.70967 23.252 1.45965C23.152 1.30964 23.052 1.20963 22.902 1.05961C22.802 0.809592 22.652 0.659579 22.552 0.55957Z"
      fill="#42ADE2"
    />
    <path
      d="M4.00748 8.00775C3.00739 8.45779 2.65736 9.6579 3.1074 10.658L9.40795 23.8091L12.9083 22.159L6.60771 8.95784C6.15767 7.95775 5.00757 7.50771 4.00748 8.00775ZM20.5589 18.4587L24.2593 16.7085L17.0586 1.7072C16.5586 0.707113 15.3585 0.257073 14.3084 0.757117C13.3083 1.25716 12.8583 2.45727 13.3583 3.50736L20.5589 18.4587Z"
      fill="#FFDD67"
    />
    <path
      d="M14.3547 0.709162C14.2547 0.759167 14.1547 0.809171 14.0547 0.90918C15.0048 0.659158 16.0049 1.1092 16.4549 2.00928L23.6555 17.0106L24.3056 16.7106L17.105 1.70925C16.6049 0.659158 15.4048 0.209118 14.3547 0.709162Z"
      fill="#EBA352"
    />
    <path
      d="M12.9026 22.1107L16.7529 20.2605L9.40227 4.95918C8.90223 3.90909 7.60211 3.40904 6.55202 3.90909C5.50193 4.40913 5.05189 5.70924 5.55194 6.75934L12.9026 22.1107Z"
      fill="#FFDD67"
    />
    <path
      d="M6.55393 3.95908C6.45392 4.00909 6.35392 4.05909 6.25391 4.1591C7.20399 3.90908 8.30409 4.35912 8.75413 5.3092L13.3045 14.86L14.4046 15.5101L9.40418 5.00918C8.90414 3.90908 7.65403 3.45904 6.55393 3.95908Z"
      fill="#EBA352"
    />
    <path
      d="M16.1526 19.0602L20.0029 17.2101L12.6523 1.90874C12.1522 0.85865 10.8521 0.358606 9.80202 0.908654C8.75193 1.4087 8.30189 2.70881 8.80194 3.7589L16.1526 19.0602Z"
      fill="#FFDD67"
    />
    <path
      d="M9.79975 0.857522C9.69975 0.907527 9.59974 1.00754 9.49973 1.05754C10.4498 0.807518 11.5499 1.25756 11.9999 2.20764L17.1504 13.0086L18.2505 13.6586L12.65 1.90761C12.15 0.807518 10.8498 0.357479 9.79975 0.857522ZM3.99925 8.00815C3.89924 8.05815 3.79923 8.10816 3.69922 8.20817C4.5993 7.95814 5.54938 8.40818 5.94942 9.30826L9.69975 17.1589L10.7998 17.809L6.59947 9.00824C6.14943 7.95814 4.99933 7.5081 3.99925 8.00815Z"
      fill="#EBA352"
    />
    <path
      d="M29.4018 6.51025C28.0517 5.46016 25.8515 6.61026 24.7514 10.2106C24.0014 12.7108 23.9014 13.4609 22.3012 14.2109L21.4011 12.3608C21.4011 12.3608 7.1999 19.2114 7.74995 20.3115C7.74995 20.3115 9.4501 25.6119 12.3504 28.0621C16.6507 31.7625 26.7016 27.8121 27.1516 18.2613C27.4017 12.7108 30.852 7.66035 29.4018 6.51025Z"
      fill="#FFDD67"
    />
    <path
      d="M29.4045 6.50823C29.1545 6.30822 28.8545 6.20821 28.5544 6.1582C28.6044 6.20821 28.7044 6.20821 28.7544 6.25821C30.2546 7.40831 28.7044 10.0585 27.8544 12.4588C27.1543 14.3589 26.5543 16.3091 26.6543 18.2093C27.0543 26.51 18.7036 30.4603 13.7031 28.9602C18.6036 31.0104 27.7044 27.11 27.3043 18.4593C27.2043 16.5591 27.7544 14.709 28.5044 12.7088C29.3045 10.3086 30.8546 7.65833 29.4045 6.50823Z"
      fill="#EBA352"
    />
    <path
      d="M22.7534 14.0088C19.6531 14.3588 15.1027 18.8092 18.303 23.6596C15.9528 18.7592 19.8032 15.4589 22.2534 14.3088C22.5034 14.1088 22.7534 14.0088 22.7534 14.0088Z"
      fill="#EBA352"
    />
  </svg>
);
const ValidateInfoSVG = () => {
  return (
    <svg width={47} height={47} viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width={47} height={47} rx="23.5" fill="#F8A026" fillOpacity="0.2" />
      <rect x={3} y={3} width={41} height={41} rx="20.5" fill="#F8A026" />
      <path
        d="M22.4058 15.144C23.0183 14.6278 24.007 14.6278 24.602 15.144L25.9845 16.3253C26.247 16.544 26.7458 16.7278 27.0958 16.7278H28.5833C29.5108 16.7278 30.272 17.489 30.272 18.4165V19.904C30.272 20.254 30.4558 20.744 30.6745 21.0065L31.8558 22.389C32.372 23.0015 32.372 23.9903 31.8558 24.5853L30.6745 25.9678C30.4558 26.2303 30.272 26.7203 30.272 27.0703V28.5578C30.272 29.4853 29.5108 30.2465 28.5833 30.2465H27.0958C26.7458 30.2465 26.2558 30.4303 25.9933 30.649L24.6108 31.8303C23.9983 32.3465 23.0095 32.3465 22.4145 31.8303L21.032 30.649C20.7695 30.4303 20.2708 30.2465 19.9295 30.2465H18.3983C17.4708 30.2465 16.7095 29.4853 16.7095 28.5578V27.0615C16.7095 26.7203 16.5345 26.2215 16.3158 25.9678L15.1345 24.5765C14.627 23.9728 14.627 22.9928 15.1345 22.389L16.3158 20.9978C16.5345 20.7353 16.7095 20.2453 16.7095 19.904V18.4253C16.7095 17.4978 17.4708 16.7365 18.3983 16.7365H19.912C20.262 16.7365 20.752 16.5528 21.0145 16.334L22.4058 15.144Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M23.5 20.1133V24.3395" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23.4951 27H23.503" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
const ValidateErrorSVG = () => {
  return (
    <svg width={47} height={48} viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width={47} height={47} rx="23.5" fill="#F82643" fillOpacity="0.2" />
      <rect x={3} y="3.5" width={41} height={41} rx="20.5" fill="#F82643" />
      <path d="M23.5 21.375V25.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M23.5 32.2339H18.1975C15.1613 32.2339 13.8925 30.0639 15.3625 27.4126L18.0925 22.4951L20.665 17.8751C22.2225 15.0664 24.7775 15.0664 26.335 17.8751L28.9075 22.5039L31.6375 27.4214C33.1075 30.0726 31.83 32.2426 28.8025 32.2426H23.5V32.2339Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M23.4952 28.375H23.5031" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
const AddressBookSVG = () => {
  return (
    <svg width={18} height={19} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.625 14V5.75C2.625 2.75 3.375 2 6.375 2H11.625C14.625 2 15.375 2.75 15.375 5.75V13.25C15.375 13.355 15.375 13.46 15.3675 13.565"
        stroke="#606060"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.7625 11.75H15.375V14.375C15.375 15.8225 14.1975 17 12.75 17H5.25C3.8025 17 2.625 15.8225 2.625 14.375V13.8875C2.625 12.71 3.585 11.75 4.7625 11.75Z"
        stroke="#606060"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 5.75H12" stroke="#606060" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 8.375H9.75" stroke="#606060" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

const CreditCardSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 63"
      width="100"
      height="63"
      role="img"
      aria-label="Credit and debit cards accepted"
    >
      <rect x="0.75" y="0.75" width="98.5" height="61.5" rx="7" fill="#fff" stroke="#d0d5dd" stroke-width="1.5" />
      <rect x="0.75" y="12" width="98.5" height="11" fill="#344054" />
      <rect x="10" y="32" width="16" height="12" rx="2.5" fill="#e3b23c" />
      <path d="M18 32v12M10 38h16" stroke="#c08f24" stroke-width="1.2" />
      <path
        d="M72 32a7 7 0 0 1 0 12M78 29a12 12 0 0 1 0 18M84 26a17 17 0 0 1 0 24"
        fill="none"
        stroke="#98a2b3"
        stroke-width="2.4"
        stroke-linecap="round"
      />
      <rect x="10" y="50" width="34" height="4" rx="2" fill="#eaecf0" />
    </svg>
  );
};
export {
  logo,
  headerLogo,
  wellExperienced,
  fastDelivery,
  leadingBrand,
  audio,
  automotive,
  avtv,
  cableConnectors,
  celluar,
  communication,
  dataComputer,
  electronic,
  power,
  security,
  acceptablePayments,
  service,
  footerLogo,
  brand1,
  category1,
  category2,
  category3,
  audioTechnicaLogo,
  subBrand1,
  subBrand2,
  subBrand3,
  subBrand4,
  subBrand5,
  subBrand6,
  subBrand7,
  subBrand8,
  product2,
  product3,
  product4,
  product5,
  product6,
  product7,
  product8,
  product9,
  product10,
  product11,
  product12,
  product13,
  product14,
  product15,
  product16,
  product17,
  product18,
  product19,
  product20,
  product21,
  shoppingCart,
  accPaySvg,
  masterSvg,
  visaSvg,
  cardsSvg,
  walletSvg,
  noInternet,
  pdfDownloadSuccess,
  MyAccountHandSVG,
  ValidateInfoSVG,
  ValidateErrorSVG,
  instructions,
  signupImg,
  walletNoCard,
  excelUpload,
  noAddressSvg,
  AddressBookSVG,
  amexSvg,
  pdfOutlineSvg,
  eyeOpenSvg,
  trackingSvg,
  gpaySvg,
  gpayWalletSvg,
  gpayWalletNewSvg,
  feedbackSvg,
  ccCardsSvg,
};
